//引入接口文档
import req from '@/utils/req.js'

//获取疾病类型/主要诊断
export function api_disease_type(params) {
    return req.get("/admin/disease-type",params);
}
//获取打卡用药数据
export function api_getDrugData(params) {
    return req.post("/admin/drug-new/page",params);
}
//获取民族
export function api_getNation(params) {
    return req.get("/admin/category/nationality/children",params);
}
//职业列表
export function api_profession(params) {
    return req.get("/admin/category/profession/children",params);
}
//体力劳动等级
export function api_manualLabour (params) {
    return req.get("/admin/category/manual_labor_grade/children",params);
}
//获取胎数
export function PatientEmbryoNumberEnum (params) {
    return req.get("/admin/enums/com.dsicm.patient.enums.PatientEmbryoNumberEnum",params);
}
//获取血型
export function api_BloodType (params) {
    return req.get("/admin/enums/com.dsicm.patient.enums.BloodTypeEnum",params);
}
//获取性别
export function api_SexType (params) {
    return req.get("/admin/enums/com.dsicm.data.metadata.enums.GenderEnum",params);
}
//获取患者状态
export function api_PatientTypeEnum(params) {
    return req.get("/admin/enums/com.dsicm.patient.enums.InHospitalStatusEnum",params);
}
//请求问卷
export function listGroupByExamType (params) {
    return req.post("/admin/qs-exam-paper/listGroupByExamType",params);
}
//获取检验二级数据
export function FindStandardCategoryByType (params) {
    return req.post("/admin/standard-category/FindStandardCategoryByType",params);
}
//获取检验三级数据
export function getInspectionInfoByTypeIdAndName (params) {
    return req.post("/admin/inspection-info/getInspectionInfoByTypeIdAndName",params);
}
//获取治疗二级数据
export function getStandardCategoryByTypeAndName (params) {
    return req.post("/admin/standard-category/getStandardCategoryByTypeAndName",params);
}
//获取治疗三级数据
export function getTreatmentItemByTypeIdAndName (params) {
    return req.post("/admin/treatment-item/getTreatmentItemByTypeIdAndName",params);
}

//获取症状数据
export function symptomList(params) {
    return req.post("/admin/symptom/page",params);
}

//获取标签数据
export function queryTagList(params) {
    return req.get("/admin/patient-group/queryTagList",params);
}